// The driving school's Toyota Yaris „L” — the car you sit in for a practical lesson or the
// practical exam. Phaser-free so it loads under `node --test`.
//
// It is NOT one of your cars: it never appears in `cars.owned`, never parks, never refuels
// and the server keeps no vehicle-registry entry for it. All the client needs to drive it
// is a record shaped like an owned car (CarController reads `id/model/plate/fuel/...`) and
// an id the server recognises as ours: `school:<my player id>` (see ws.py — it checks the
// suffix against the sender's own id and forces `car_model: 'yaris_l'`).

export const SCHOOL_CAR_PREFIX = 'school:';
export const SCHOOL_CAR_MODEL = 'yaris_l';
export const SCHOOL_CAR_PLATE = 'L';
export const SCHOOL_CAR_FUEL = 45;          // litres — the tank never moves off full
export const SCHOOL_CAR_NAME_PL = 'Toyota Yaris „L”';

/** Is this a school car id (`school:<player id>`)? Those never park and never get a tag. */
export function isSchoolCarId(carId) {
  return typeof carId === 'string' && carId.startsWith(SCHOOL_CAR_PREFIX);
}

/**
 * A car record for the instructor's Yaris, shaped like an owned car so the whole driving
 * pipeline (sprite, physics, HUD, broadcast) works on it unchanged.
 * `myId` is the player id the server knows us by (`window.__myId`).
 */
export function schoolCarRecord(myId) {
  return {
    id: `${SCHOOL_CAR_PREFIX}${myId ?? ''}`,
    model: SCHOOL_CAR_MODEL,
    name_pl: SCHOOL_CAR_NAME_PL,
    plate: SCHOOL_CAR_PLATE,
    fuel: SCHOOL_CAR_FUEL,
    fuel_kind: 'pb95',
    odometer_m: 0,
    broken: false,
  };
}

/**
 * The one row the school car's exit menu has, plus the confirmation behind it. Breaking off
 * a lesson merely cancels it; breaking off an EXAM burns the attempt, so the wording has to
 * say so before the child taps it.
 */
export function abortMenu(kind) {
  return kind === 'exam'
    ? {
      label: 'Przerwij egzamin',
      title: 'Przerwać egzamin?',
      body: 'Egzamin będzie oblany, a następne podejście dopiero jutro.',
      confirmLabel: 'Przerywam',
    }
    : {
      label: 'Przerwij lekcję',
      title: 'Przerwać lekcję?',
      body: 'Lekcja się nie zaliczy — wrócisz przed szkołę.',
      confirmLabel: 'Przerywam',
    };
}

/** What the toast says once the abort went through. */
export function abortToast(kind) {
  return kind === 'exam' ? 'Egzamin przerwany — następne podejście jutro' : 'Lekcja przerwana';
}
